import { Box } from "@mui/material";
import React from "react";
import ReactApexChart from "react-apexcharts";
import { useSelector } from "react-redux";

export default function ColumnChart() {
  const state = useSelector((store) => store.analyze);
  const { columnChartDataPrepared, selectedScenarioName, duration } = state;
  const { categories, values,localNos } = columnChartDataPrepared;

  // const colorMapping = {
  //   TTM: "#0000FF",
  //   IMS: "#000000",
  //   MDR: "#964B00",
  //   "LE Diagnostics": "green",
  //   "Final Quota": "#FF9800",
  //   "Original Quota": "#F57C00",
  //   Month: "#800080",
  // };

  const colorMapping = {
    "Ex-Factory": "#3366cc",
    "DeliveredQTY": "#ADD8E6",
    "IQVIA - MIDAS": "#000000",
    SIT: "#896129",
    Forecast: "#008000",
    "Final Quota": "#FF9800",
    "Original Quota": "#F57C00",
    "Quota": "#F57C00",
    "Financial Forecast":"#006400",
    "Supply Chain Forecast" :"#FF00FF",
    "AI Forecast":"#EC5066",
    "xyz - system2":"#000000",
    Month: "#800080",
  };  

  // Function to get color based on category from the colorMapping
  const getColorForCategory = (categoryName, colorMapping) => {
    console.log("localNos",localNos);
    const locNo = localNos.find((item) => item.series === categoryName);

    if(locNo.localNo ===1){
      return "#a206a2";
    }
    else if(locNo.localNo===2){
      return "#c152c1";
    }
    else if(locNo.localNo===3){
    return "#d099d0";
    }
    else{
    return colorMapping[categoryName] || "#0e0e0e"; // default color if category not found
    }
  };

  const options = {
    chart: {
      id: "basic-bar",
    },
    title: {
      text: `${selectedScenarioName} Last ${duration} Months`,
      align: "left",
    },
    plotOptions: {
      bar: {
        horizontal: false,
        //columnWidth: "55%",
        columnWidth: "100%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (value) => {
        const formatter = new Intl.NumberFormat("en-US");
        return formatter.format(value);
      },
    },

    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    fill: {
      opacity: 1,
    },
    xaxis: {
      categories: [...categories],
    },
    yaxis: {
      labels: {
        formatter: (value) => {
          const formatter = new Intl.NumberFormat("en-US");
          return formatter.format(value);
        },
      },
    },
    tooltip: {
      y: {
        formatter: (value) => {
          const formatter = new Intl.NumberFormat("en-US");
          return formatter.format(value);
        },
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "right", // Aligns the legend to the right
      floating: true,
      offsetY: -10, // Adjusts vertical alignment if necessary
      offsetX: -5, // Adjusts horizontal alignment if necessary
    },
  };
  const series = [
    {
      name: "value",
      //data: [...values],
      data: categories.map((category, index) => ({
        x: category,
        y: values[index], // Replace with your actual y value
        fillColor: getColorForCategory(category, colorMapping),
      })),
    },
  ];

  return (
    <Box className={"columnChart"}>
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={410}
        width={"95%"}
      />
    </Box>
  );
}
